import type { Pet } from '.';
import { defineAsyncGetters } from '../../utils';

export const petAsyncGetters = (Pet: Pet) =>
  defineAsyncGetters<Pet>()({
    getNextPetState: async (playerId: string, api) => {
      const statesMap = await api.fetchStates([playerId]);
      const playerState = statesMap[playerId];
      if (!playerState) {
        return null;
      }

      return Pet.getters(playerState.state).getNextPetState(api.date.now());
    },
  });
